/* eslint-disable no-redeclare */
/**
 * @See https://github.com/healthcarecom/sem-content#get-campaign-of-calls
 */

import type { CallType, CampaignPlacement } from '@hc-frontend/core-types';
import { z } from 'zod';

export const CallCampaignProductType = z.enum([
  'HEALTH',
  'MEDICARE',
  'MEDICARE_ADVANTAGE',
  'MEDICARE_SUPPLEMENT',
]);
export type CallCampaignProductType = z.infer<typeof CallCampaignProductType>;

export interface GetCallCampaignPayload {
  product: CallCampaignProductType;
  placement: CampaignPlacement;
  site: string;
  src: string;
  call_type: CallType;
  publisher_click_id: string;
  session_id: string;
  user_id: string;
  sub_id: string | number;
  partner_sub_id: string;
  experiment_id: string;
  variation_id: string;
  device: string;
  state: string;
  zip: string;
  request_url: string;
  profile: {
    qle?: number;
    familySize: number;
    fpl: string;
    tobacco: string | null;
    gender: 'm' | 'f';
    age: number;
  };
}
